import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';
import asObject from 'utils/objects/asObject.util';

const ATAG = 'beDeleteTimeOffCategory';
const AT = actionType(ATAG);

const beDeleteTimeOffCategory = (options) => {
  const { salonId, id } = asObject(options);

  return endpoint(H.del, 'salon/v2/:salonId/time_off_categories/:id/', {
    AT,
    name: ATAG,
    params: { salonId, id },
  });
};

beDeleteTimeOffCategory.AT = AT;
beDeleteTimeOffCategory.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beDeleteTimeOffCategory;
